import * as _ from 'underscore';

import { call, put } from 'redux-saga/effects';
import { Messages } from '../../../../codegen/Localize';
import { IDataSourceInfo } from '../../../../ts/models/IDataSourceInfo';
import { Set } from '../../../../ts/models/Set';
import { ChangeExtractDsToLiveAction as AngularChangeExtractDsToLiveAction } from '../../../../ts/services/ChangeExtractDsToLiveAction';
import { requestFailed } from '../../../actions/RequestFailedAction';
import { ChangeExtractDsToLiveAction } from '../../../actions/spaces/ChangeExtractDsToLiveAction';
import { ServiceLocator } from '../../../ServiceLocator';

export function* handleChangeExtractDsToLiveAction(action: ChangeExtractDsToLiveAction) {

  try {
    yield call(openChangeExtractDsToLiveWindow,  action.datasources);
  } catch (e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

export function openChangeExtractDsToLiveWindow(datasources: IDataSourceInfo[]) {
  const context = ServiceLocator.getAngularActionContext();
  const angularChangeExtractDsToLiveAction = ServiceLocator.get<AngularChangeExtractDsToLiveAction>('ChangeExtractDsToLiveAction');
  return angularChangeExtractDsToLiveAction.execute(Set.fromIdItemArray(datasources), context);
}
